'use strict';
(function (angular) {
	angular.module('pmtPlacesApp.directives').component('pmtApiPendingChangesResolver', {
		controller: ApiChanges,
		template: `<pmt-elm ng-if="$ctrl.args && $ctrl.api" module="ApiPendingChanges.Resolver.Main" args="$ctrl.args"></pmt-elm>`
	});

	ApiChanges.$inject = ['$stateParams', 'pmtSiteService', 'auth'];

	function ApiChanges($stateParams, pmtSiteService, auth) {
		let $ctrl = this;
		$ctrl.site = $stateParams.site;

		pmtSiteService.getSite().then(site =>
			auth.getUser(site.name).then(user => {
				$ctrl.api = site.places.api.enabled;
				$ctrl.args = {
					siteName: site.name,
					displayName: site.displayName,
					today: new Date().toISOString(),
					user: auth.userForPinMeToPage(user)
				};
			})
		);
	}
})(window.angular);
